module.exports = __webpack_public_path__ + "public/img/Dasar Microsoft Excel Untuk Administrasi Perkantoran.e6e3bbff.png";